/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    export interface IStateMap {
        [key: string]: boolean;
    }

    /**
     * Factory callback type
     */
    declare type ColumnFilterDirectiveFactoryCb = () => ColumnFilterDirective;

    /**
     * Custom scope
     */
    export interface IColumnFilterDirectiveScopeDef {
        model: string;
        attribute: string;
        stateMap: string;
        modifier: string;
    }

    /**
     * Custom scope
     */
    export interface IColumnFilterDirectiveScope extends ng.IScope {
        model: any[]; // tslint:disable-line
        attribute: string;
        stateMap: IStateMap;
        modifier: () => ((severity: number) => string);

        initializeMap: () => void;
        updateMap: (newModel: any) => void; // tslint:disable-line
        updateAllValueFilter: () => void;
        changeFilterMaps: (value: boolean, key: string) => void;
        propertyInModel: (model: any[], propertyValue: string) => boolean; // tslint:disable-line
        filterAdd: (map: Object) => Object;
        allValue: string;
        modifierExists: boolean;
    }

    /**
     * Bar directive
     */
    export class ColumnFilterDirective implements ng.IDirective {
        public static ALL_VALUE: string = "All";
        public static $name: string = "columnFilter";

        public link: (scope: IColumnFilterDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'AE';
        public transclude: boolean = false;
        public replace: boolean = true;
        public templateUrl: string = 'decorators/column-filter-directive.html';
        public scope: IColumnFilterDirectiveScopeDef = {
            model: '=',
            attribute: '@',
            stateMap: '=',
            modifier: '&',
        };

        /**
         * Factory for the directive
         */
        public static Factory(): ColumnFilterDirectiveFactoryCb {
            let directive: ColumnFilterDirectiveFactoryCb = () => {
                return new ColumnFilterDirective();
            };
            return directive;
        }

        /**
         * Constructor
         */
        constructor() {
            ColumnFilterDirective.prototype.link = ($scope: IColumnFilterDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                $scope.modifierExists = attrs.$attr.hasOwnProperty('modifier');
                $scope.allValue = ColumnFilterDirective.ALL_VALUE;
                $scope.$watch('model', (newValue: any[], oldValue: any[]) => { // tslint:disable-line
                    if (newValue && newValue !== oldValue) {
                        $scope.updateMap(newValue);
                    }
                }, true);

                $scope.changeFilterMaps = (value: boolean, key: string) => {
                    if (key !== ColumnFilterDirective.ALL_VALUE) {
                        $scope.stateMap[key] = value;
                        $scope.updateAllValueFilter();                    
                    } else {
                        for (let property in $scope.stateMap) {
                            if ($scope.stateMap.hasOwnProperty(property)) {
                                $scope.stateMap[property] = value;
                            }
                        }
                    }
                };

                $scope.updateAllValueFilter = () => {
                    let allValues: boolean = true;
                    for (let property in $scope.stateMap) {
                        if (property !== ColumnFilterDirective.ALL_VALUE && $scope.stateMap.hasOwnProperty(property)
                            && $scope.stateMap[property] !== true) {
                            allValues = false;
                        }
                    }
                    $scope.stateMap[ColumnFilterDirective.ALL_VALUE] = allValues;
                };

                $scope.initializeMap = () => {
                    $scope.model.forEach((value: any) => { // tslint:disable-line
                        $scope.stateMap[ColumnFilterDirective.ALL_VALUE] = true;

                        if (!$scope.stateMap[value[$scope.attribute]])
                            $scope.stateMap[value[$scope.attribute]] = true;
                    });
                };

                $scope.updateMap = (newModel: any[]) => { // tslint:disable-line
                    newModel.forEach((value: any) => { // tslint:disable-line
                        if ($scope.stateMap[ColumnFilterDirective.ALL_VALUE] === undefined) 
                            $scope.stateMap[ColumnFilterDirective.ALL_VALUE] = true;

                        if ($scope.stateMap[value[$scope.attribute]] === undefined) {
                            $scope.stateMap[value[$scope.attribute]] = true;
                        }
                    });

                    for (let property in $scope.stateMap) {
                        if (property !== ColumnFilterDirective.ALL_VALUE && $scope.stateMap.hasOwnProperty(property)
                            && !$scope.propertyInModel(newModel, property)) {
                            delete $scope.stateMap[property];
                        }
                    }
                };

                $scope.filterAdd = (map: Object) => {
                    let result: Object = {};
                    angular.forEach(map, function(value, key) { // tslint:disable-line
                        if (map.hasOwnProperty(key) && key !== ColumnFilterDirective.ALL_VALUE) {
                            result[key] = value;
                        }
                    });
                    return result;
                };

                $scope.propertyInModel = (model: any[], propertyValue: string) => { // tslint:disable-line
                    return model.some((value: any) => { // tslint:disable-line
                        return value.hasOwnProperty($scope.attribute) && value[$scope.attribute] !== undefined
                            && value[$scope.attribute] !== null
                            && value[$scope.attribute].toString() === propertyValue;
                    });
                };
            };
        }
    }
}
